<dx-popup title="Comments"
          [width]="680"
          [height]="325"
          [showTitle]="true"
          [dragEnabled]="true"
          [closeOnOutsideClick]="false"
          [showCloseButton]="false"
          [(visible)]="popupVisible"
          (close)="close()"
          (onHidden)="hidden()"
>
  <dxi-toolbar-item location="after">
    <dx-button text="Close" (click)="close()"></dx-button>
  </dxi-toolbar-item>
  <div *dxTemplate="let data of 'content'" style="height: 100%">
    <app-comments-control [control]="control"></app-comments-control>
  </div>
</dx-popup>
